<template>
  <div class="c-table-cell">
    <div class="c-table__cell-value">
      <candidates-source-icon :source-id="data.source.id" />
    </div>
  </div>
</template>

<script>
import CandidatesSourceIcon from "@/pages/staff/candidates/components/candidates-source-icon";

export default {
  name: "source-cell",
  components: {
    CandidatesSourceIcon,
  },
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },
};
</script>

<style scoped>
.c-table__cell-value {
  display: flex;
  justify-content: center;
}
</style>
